export default {
  basketId: '0747-cdd5498f-2019-42f1-a5ab-7a1ddabf84fd',
  title: 'Aparthotel Adagio Paris Bercy Village',
  stars: 4,
  personDates: '1 adult - 6 Jun to 7 Jun (1 night)',
  filterString: 'For 3 nights | 2 adults - 1 child - 1 baby',
  roomType: 'Studio for 2 persons',
  promo: null,
  label: 'Adagio',
  hotelLink: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
  imgSrc: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
  minutes: 'À 2 min de la Tour Eiffel',
  rate: 4.5,
  rateFull: 5,
  rates: 'Non flexible',
  service: {
    href: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
    title: 'Voir tous les services',
  },
  vote: {
    href: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
    title: 'Voir les 136 avis',
  },
  location: {
    text: '14 rue du Théâtre 75015 Paris',
    title: 'Voir sur la carte',
    href: 'https://google.com',
  },
  featureImages: [
    {
      className: 'icon-ANIMALS',
      label: 'Ouvert 24H/24 7J/7 toute l’année',
    },
    {
      className: 'icon-ANIMALS',
    },
    {
      className: 'icon-ANIMALS',
      label: 'Ouvert 24H/24 7J/7 toute l’année',
    },
    {
      className: 'icon-ANIMALS',
    },
  ],
  payment: {
    hotel: {
      label: 'To be paid at the aparthotel',
      price: '10.00€',
    },
    prepay: {
      label: 'Amount to be prepaid:',
      price: '153.06€',
    },
    total: {
      label: 'Total',
      detailsLabel: 'Total',
      subtitle: '(taxes included)',
      price: '186.88€',
    },
  },
  expiration: {
    expire: 1541605109,
    title: 'Basket was expired',
    description: 'The basket has expired, please, choose the room rates again.',
    linkTitle: 'Reload page',
    linkUrl: 'http://google.com',
  },
  checkbox: 'ByBy clicking on "Confirm your booking", I accept the <a href="https://google.com">Internet sales conditions</a> and the <a href="#conditions">conditions of sale and rate cancellation</a>.',
  button: {
    title: 'Book',
    url: '/en/booking/checkout',
  },
  description: 'You will not be charged. This step validates your reservation',
  details: {
    title: 'Details',
    url: '/en',
  },
  paymentDetails: {
    title: 'Payment details',
    nights: {
      title: '5 Nights',
      price: '186.00€',
    },
    includedTitle: 'Tax included',
    taxIncluded: {
      title: 'VAT',
      price: '186.00€',
    },
    notIncludedTitle: 'Tax(es) not included',
    taxNotIncluded: [
      {
        title: 'City and local taxess',
        price: '0.88€',
      },
    ],
    benefit: {
      title: 'Member advantage ALL - Accor Live Limitless',
      price: '-18.68€',
    },
    currencyUser: {
      title: 'Vous paierez dans la devise du pays que vous visitez',
      price: '58 020¥',
    },
    currency: {
      title: 'Member advantage ALL - Accor Live Limitless',
      price: '-18.69€',
    },
    optionsTitle: 'Options',
    options: [
      {
        title: 'Breakfest',
        id: 1,
        price: '81€;',
      },
      {
        title: 'Breakfest include',
        id: 2,
        price: '82€;',
      },
    ],
  },
  apartments: [
    {
      personDates: '2 adults - 8 Dec to 9 Dec (1 night)',
      roomType: 'Studio for 2 persons',
      label: 'Apartment 1',
      details: 'Details',
      roomId: '1',
      roomRateId: 'abc',
      adults: 2,
      childrenAges: [2, 11, 11, 11],
      rates: 'Non flexible',
    },
    {
      personDates: '2 adults - 8 Dec to 9 Dec (1 night)',
      roomType: 'Studio for 2 persons',
      label: 'Apartment 2',
      details: 'Details',
      roomId: '1',
      roomRateId: 'abc',
      adults: 2,
      childrenAges: [],
      rates: 'flexible',
    },
  ],
}
